import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['../../theme.scss']
})
export class BaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
